export const webComponentsRoutes = [
  {
    path: "/especialidades/",
    name: "especialidades",
  },
  {
    path: "/especialidades/:specialty",
    name: "especialidade",
  },
  {
    path: "/specialties/",
    name: "specialties",
  },
  {
    path: "/specialties/:specialty",
    name: "specialty",
  },
];
